import React from "react";

/**
 * Stat tile (E §8): micro-caps label + big tabular number + optional
 * sub-line. Estimated money values should be passed with a leading "~"
 * by the caller — the tilde is the app-wide "estimate" mark.
 */
function StatTile({ label, value, sub }) {
  return (
    <div className="fk-stattile">
      <span className="fk-stattile__label">{label}</span>
      <span className="fk-stattile__value">{value}</span>
      {sub ? <span className="fk-stattile__sub">{sub}</span> : null}
    </div>
  );
}

export default StatTile;
